import { c as _c } from "react/compiler-runtime";
import './PreviewButton.scss';
import { useContext, useEffect, useState } from 'react';
import { Button } from '../../../atom/Button/Button';
import { Modal } from '../../../atom/Modal/Modal';
import { CustomEditorContext } from '..';

/**
 * 에디터 툴바의 미리보기 버튼
 */
export const PreviewButton = () => {
  const $ = _c(11);
  const {
    editor
  } = useContext(CustomEditorContext);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [content, setContent] = useState("");
  let t0;
  let t1;
  if ($[0] !== editor || $[1] !== isModalOpened) {
    t0 = () => {
      if (isModalOpened && editor) {
        const contentHtml = editor.getHTML();
        setContent(contentHtml);
      }
    };
    t1 = [isModalOpened, editor];
    $[0] = editor;
    $[1] = isModalOpened;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button dimensions="H26" onClick={() => {
      setIsModalOpened(true);
    }}>미리보기</Button>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsModalOpened(false);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content) {
    t4 = <div className="max-h-full overflow-auto"><article className="text-start text-Gray-black" dangerouslySetInnerHTML={{
        __html: content
      }} /></div>;
    $[6] = content;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isModalOpened || $[9] !== t4) {
    t5 = <>{t2}<Modal className="preview-button-modal max-h-[90vh] w-full max-w-[800px]" opened={isModalOpened} onClose={t3}>{t4}</Modal></>;
    $[8] = isModalOpened;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};